<section
    class="hero-banner"
    [ngClass]="{
        'hero-banner--text-color-white': block.data.textColor === 'white',
        'hero-banner--text-color-black': block.data.textColor === 'black',
        'hero-banner--no-padding-y': block.data.removePaddingY,
        'hero-banner--inner-page-split-layout': block.data.layout === 'split-hero',
    }"
    [style]="`--bg: ${getBackground()}`">
    <!-- Content -->
    <div class="hero-banner__content">
        <ng-container *ngTemplateOutlet="headingTemplate"></ng-container>

        @if (block.data.subheading && block.data.isManualContent) {
            <h2
                class="hero-banner__subheading"
                [innerHTML]="block.data.subheading"
                [ngClass]="{
                    'hero-banner__subheading--text-color-base': block.data.subheadingTextColor === 'base',
                    'hero-banner__subheading--text-color-primary': block.data.subheadingTextColor === 'primary',
                    'hero-banner__subheading--text-color-secondary': block.data.subheadingTextColor === 'secondary',
                    'hero-banner__subheading--text-color-heading': block.data.subheadingTextColor === 'heading',
                    'hero-banner__subheading--text-color-action': block.data.subheadingTextColor === 'action',
                    'hero-banner__subheading--text-size-small': block.data.subheadingTextSize === 'small',
                    'hero-banner__subheading--text-size-medium': block.data.subheadingTextSize === 'medium',
                    'hero-banner__subheading--text-size-large': block.data.subheadingTextSize === 'large',
                }"></h2>
        }

        @if (!block.data.isManualContent || block.data.description) {
            <div class="hero-banner__description">
                <p [innerHTML]="block.data.isManualContent ? block.data.description : pageDescription"></p>
            </div>
        }

        @if (block.data.ctaLabel) {
            <a
                class="btn btn-primary hero-banner__ctaLink"
                [href]="block.data.ctaLink"
                [target]="block.data.isCtaExternalLink ? '_target' : '_self'"
                >{{ block.data.ctaLabel }}</a
            >
        }
    </div>

    <!-- Image -->
    @if (block.data.includeFgImage) {
        <img
            class="hero-banner__foreground-image"
            [ngClass]="{
                'hero-banner__foreground-image--is-full-bleed-right': block.data.isFullBleedRight,
                'hero-banner__foreground-image--hide-on-mobile': block.data.hideImageOnMobile,
                'hero-banner__foreground-image--hide-on-tablet': block.data.hideImageOnTablet,
                'hero-banner__foreground-image--hide-on-small-desktop': block.data.hideImageOnSmallDesktop,
            }"
            [ngStyle]="{
                'object-fit': block.data.fgObjectFit,
            }"
            [src]="block.data.fgImage"
            alt="" />
    }
</section>

<ng-template #headingTemplate>
    @if (block.data.isManualContent && block.data.isStackedHeading) {
        <h1
            class="hero-banner__heading"
            [ngClass]="{
                'hero-banner__heading--text-color-base': block.data.headingTextColor === 'base',
                'hero-banner__heading--text-color-primary': block.data.headingTextColor === 'primary',
                'hero-banner__heading--text-color-secondary': block.data.headingTextColor === 'secondary',
                'hero-banner__heading--text-color-heading': block.data.headingTextColor === 'heading',
            }">
            <span
                class="hero-banner__heading-top"
                [ngClass]="{
                    'hero-banner__heading-top--text-style-outline': block.data.isHeadingTopOutlined,
                }"
                >{{ block.data.headingTop }}</span
            >
            <span
                class="hero-banner__heading-bottom"
                [ngClass]="{
                    'hero-banner__heading-bottom--text-style-outline': block.data.isHeadingBottomOutlined,
                }"
                >{{ block.data.headingBottom }}</span
            >
        </h1>
    } @else {
        <h1
            class="hero-banner__heading"
            [innerText]="block.data.isManualContent ? block.data.heading : pageName"
            [ngClass]="{
                'hero-banner__heading--text-color-base': block.data.headingTextColor === 'base',
                'hero-banner__heading--text-color-primary': block.data.headingTextColor === 'primary',
                'hero-banner__heading--text-color-secondary': block.data.headingTextColor === 'secondary',
                'hero-banner__heading--text-color-heading': block.data.headingTextColor === 'heading',
            }"></h1>
    }
</ng-template>
